@if (!nextStep) {
  <mat-card appearance="outlined">
    <mat-card-title>Mes données personnelles</mat-card-title>
    @if (!isLoading) {
      <div>
        <p class="small_size">Mon email</p>
        <p class="upper_margin"> {{ login.username }} </p>
      </div>
    }
    @if (isLoading) {
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    }
  </mat-card>
}
<mat-card appearance="outlined">
  <mat-card-title>Changer mon mot de passe</mat-card-title>
  @if (isCurrentProvider('local')) {
    <form [formGroup]="form">
      @if (!nextStep) {
        <div>
          @if (!isLoading) {
            <div>
              <p class="space">
                <mat-form-field>
                  <mat-label>Mot de passe</mat-label>
                  <input [(ngModel)]="login.password" [type]="showPassword ? 'text' : 'password'" class="password_input"
                    formControlName="password" matInput>
                    <mat-icon (click)="clickShowPassword()" class="password_button">remove_red_eye</mat-icon>
                    @if (form.get('password').hasError('required')) {
                      <mat-error>
                        Le nouveau mot de passe est requis
                      </mat-error>
                    }
                    @if (form.get('password').hasError('minlength')) {
                      <mat-error>
                        Le nouveau mot de passe doit faire au minimum 8 caractères
                      </mat-error>
                    }
                  </mat-form-field>
                </p>
                <p class="space">
                  <mat-form-field>
                    <mat-label>Confirmation de mot de passe</mat-label>
                    <input [type]="showPasswordRepeat ? 'text' : 'password'" class="password_input"
                      formControlName="passwordConfirm" matInput>
                      <mat-icon (click)="clickShowPasswordRepeat()" class="password_button">remove_red_eye</mat-icon>
                      @if (form.get('passwordConfirm').hasError('required')) {
                        <mat-error>
                          La confirmation du nouveau mot de passe est requise
                        </mat-error>
                      }
                      @if (form.get('passwordConfirm').hasError('mismatch')) {
                        <mat-error>
                          Les 2 mots de passes ne correspondent pas
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <p class="space_button">
                    <button (click)="sendConfirmationCodePassword()"
                      [disabled]="form.get('password').errors || form.get('passwordConfirm').errors" mat-button>Valider
                    </button>
                  </p>
                </div>
              }
            </div>
          }
          @if (nextStep) {
            <div>
              @if (!isLoading) {
                <div>
                  <p class="text_left">Un code de confirmation vous a été envoyé. Veuillez le saisir ci-dessous</p>
                  <p class="space">
                    <mat-form-field>
                      <mat-label>Code de confirmation</mat-label>
                      <input [(ngModel)]="login.activationCode" formControlName="confirmationCode" matInput>
                      @if (form.get('confirmationCode').hasError('required')) {
                        <mat-error>
                          Le code de confirmation est requis
                        </mat-error>
                      }
                      @if (form.get('confirmationCode').hasError('minlength') || form.get('confirmationCode').hasError('maxlength')) {
                        <mat-error
                          >
                          Le code de confirmation doit faire 6 caractères
                        </mat-error>
                      }
                    </mat-form-field>
                  </p>
                  <button (click)="validConfirmationCode()" [disabled]="form.get('confirmationCode').errors" mat-button>Valider
                  </button>
                </div>
              }
            </div>
          }
          @if (isLoading) {
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          }
        </form>
      }
      @if (isCurrentProvider('inexweb')) {
        <div>
          Votre compte est géré avec Inexweb. Pour changer votre mot de passe veuillez vous rendre sur <a
        href="https://store.inexweb.fr/my-account" rel="noopener" target="_blank">Inexweb</a>
      </div>
    }
  </mat-card>
  @if (!isLoading) {
    <div class="link_infos">
      @if (nextStep) {
        <button mat-button (click)="resendConfirmationCode(false)">Nouveau code par email</button>
      }
      @if (!nextStep) {
        <button mat-button (click)="deleteAccount()">Supprimer mon compte</button>
      }
    </div>
  }
